import React from 'react';

const VIEW_OPTIONS = [
  { value: 'grid', label: 'Grid', icon: 'grid' },
  { value: 'split', label: 'Split', icon: 'split' },
  { value: 'map', label: 'Map', icon: 'map' },
];

function LayoutToggle({ viewMode, onChange }) {
  return (
    <div className="layout-toggle">
      {VIEW_OPTIONS.map((option) => (
        <button
          key={option.value}
          className={`layout-toggle-btn ${option.value === viewMode ? 'active' : ''}`}
          onClick={() => onChange(option.value)}
          title={`${option.label} View`}
          aria-pressed={option.value === viewMode}
        >
          <LayoutIcon type={option.icon} />
        </button>
      ))}
    </div>
  );
}

function LayoutIcon({ type }) {
  switch (type) {
    case 'grid':
      // Phosphor-style squares-four icon
      return (
        <svg className="layout-icon" width="20" height="20" viewBox="0 0 256 256" fill="currentColor">
          <path d="M104,40H56A16,16,0,0,0,40,56v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V56A16,16,0,0,0,104,40Zm0,64H56V56h48ZM200,40H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40Zm0,64H152V56h48Zm-96,32H56a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,104,136Zm0,64H56V152h48Zm96-64H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,200,136Zm0,64H152V152h48Z"/>
        </svg>
      );
    case 'split':
      // Phosphor-style sidebar icon
      return (
        <svg className="layout-icon" width="20" height="20" viewBox="0 0 256 256" fill="currentColor">
          <path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM40,56H88V200H40ZM216,200H104V56H216Z"/>
        </svg>
      );
    case 'map':
      // Phosphor-style map-trifold icon
      return (
        <svg className="layout-icon" width="20" height="20" viewBox="0 0 256 256" fill="currentColor">
          <path d="M228.92,49.69a8,8,0,0,0-6.86-1.45L160.93,63.52,99.58,32.84a8,8,0,0,0-5.52-.6l-64,16A8,8,0,0,0,24,56V200a8,8,0,0,0,9.94,7.76l61.13-15.28,61.35,30.68A8.15,8.15,0,0,0,160,224a8,8,0,0,0,1.94-.24l64-16A8,8,0,0,0,232,200V56A8,8,0,0,0,228.92,49.69ZM104,52.94l48,24V203.06l-48-24ZM40,62.25l48-12v127.5l-48,12Zm176,131.5-48,12V78.25l48-12Z"/>
        </svg>
      );
    default:
      return null;
  }
}

export default LayoutToggle;
